import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TimeHandlerService {
  currentTime: number = 0;
  constructor() { }
}
